import gql from 'graphql-tag';

const getCardGroupCardsQuery = gql`
  query getCardGroupCardsQuery(
    $card_category_id: RecordID!
    $card_group_id: RecordID!
    $root_only: Boolean = true
  ) {
    cardCategories(
      slice: { offset: 0, limit: 1 }
      card_category_id: $card_category_id
      root_only: $root_only
    ) {
      total
      records {
        id
        name
        is_active
        asset_image {
          id
          url
        }
        card_groups(card_group_id: $card_group_id) {
          total
          records {
            id
            name
            cards(
              slice: { offset: 0, limit: 999 }
              card_category_id: $card_category_id
            ) {
              total
              records {
                id
                card_side_groups {
                  total
                  records {
                    id
                    side
                    asset_image {
                      id
                      url
                    }
                    card_sides {
                      total
                      records {
                        id
                        asset_image {
                          id
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default getCardGroupCardsQuery;
